import type { IPage } from '@/models/global'

const platformList = ['tb', 'jd', 'dy', 'ks', 'pdd', 'open', 'wx', 'dw', 'xhs', 'wph', 'wxxd']

export const nameIdMap: Record<string, string> = {
  // 告警大屏
  告警大屏: '6690db299ed071e51721831e',
  // 实时风险监控
  店铺实时告警: '66922f2822ab809971103a55',
  平台实时告警: '66922f2822ab809971103a4f',
  全局实时告警: '66922f2822ab809971103a49',
  实时告警报表: '6691f6d522ab80997110364b',
  // 质检报表
  全局质检汇总表: '69018eb8e48628355d7a3a60',
  全局质检标准检出表: '69128b08be2024d466e4befb',
  全局人工质检表: '6909f4f7e48628355d7a53ff',
  // 客服评价满意度
  客服评价满意度_tb: '67d2461ce63366f0474b20b0',
  客服评价满意度_jd: '6692264d22ab8099711037a3',
  // 分析洞察Agent
  龙虾: '68c1234567890abcdef12345',
  // 质检效果监控
  质检效果监控报表: '697086af895d8a4fdd0faf3f',
  // 人工质检诊断报告
  人工质检诊断报告_tb: '68a691a6ad2af9f81792f636',
  人工质检诊断报告: '68a692b3ad2af9f81792f758',

  // 质培联动-会话案例
  会话案例: '68e1234567890abcdef12347',

  // 报表中心

  子账号会话监控: '696e39a4895d8a4fdd0f9b5d',
  '全局质检报表-企业': '69844a6237998ed829ff44b5',
  人工复检会话明细表: '69bbad6ddb87e97497126968',
  全渠道店铺实时告警: '69c2793903e3bdd4b7dcfc17',
}

// dataforce页面属于哪些平台
export const idPlatformMap: Record<string, string[]> = {
  [nameIdMap['告警大屏']]: platformList,
  [nameIdMap['店铺实时告警']]: platformList,
  [nameIdMap['平台实时告警']]: platformList,
  [nameIdMap['全局实时告警']]: platformList,
  [nameIdMap['实时告警报表']]: platformList,
  [nameIdMap['全局质检汇总表']]: platformList,
  [nameIdMap['全局质检标准检出表']]: platformList,
  [nameIdMap['全局人工质检表']]: platformList,
  [nameIdMap['质检效果监控报表']]: platformList,
  [nameIdMap['客服评价满意度_tb']]: ['tb'],
  [nameIdMap['客服评价满意度_jd']]: ['jd'],
  // [nameIdMap['龙虾']]: platformList,
  [nameIdMap['效果监控']]: platformList,
  [nameIdMap['人工质检诊断报告']]: platformList.filter((item) => item !== 'tb'),
  [nameIdMap['人工质检诊断报告_tb']]: ['tb'],

  [nameIdMap['会话案例']]: platformList,
  // 报表中心
  [nameIdMap['子账号会话监控']]: platformList,
  [nameIdMap['全局质检报表-企业']]: platformList,
  [nameIdMap['人工复检会话明细表']]: platformList,
  [nameIdMap['全渠道店铺实时告警']]: platformList,
}

// dataforce 页面的 icon 配置
export const pageIconMap: Record<string, string> = {
  [nameIdMap['告警大屏']]: 'icon-78gaojingdaping',
  [nameIdMap['店铺实时告警']]: 'icon-dianpu',
  [nameIdMap['平台实时告警']]: 'icon-pingtai',
  [nameIdMap['全局实时告警']]: 'icon-quanju',
  [nameIdMap['客服评价满意度_tb']]: 'icon-kefupingjiamanyidu',
  [nameIdMap['客服评价满意度_jd']]: 'icon-kefupingjiamanyidu',
}

const V2DataforceList: Record<string, string[]> = {
  // 1. 工作台 - 告警大屏
  工作台: [nameIdMap['告警大屏']],
  // 3. 实时风险监控
  实时风险监控: [
    nameIdMap['店铺实时告警'],
    nameIdMap['平台实时告警'],
    nameIdMap['全局实时告警'],
    nameIdMap['实时告警报表'],
  ],
  // 4. 质检管理-人工质检
  人工质检: [nameIdMap['人工质检诊断报告_tb'], nameIdMap['人工质检诊断报告']],
  // 4. 质检管理-质检分析
  质检分析: [
    nameIdMap['质检诊断报告_tb'],
    nameIdMap['质检诊断报告'],
    nameIdMap['质检明细报表_tb'],
    nameIdMap['质检明细报表'],
  ],
  // 4. 质检管理-质培联动
  质培联动: [nameIdMap['会话案例']],
  // 5. 报表中心-质检报表
  质检报表: [
    nameIdMap['全局质检汇总表'],
    nameIdMap['全局质检标准检出表'],
    nameIdMap['全局人工质检表'],
  ],
  报表中心: [
    nameIdMap['子账号会话监控'],
    nameIdMap['全局质检报表-企业'],
    nameIdMap['人工复检会话明细表'],
    nameIdMap['全渠道店铺实时告警'],
  ],
  // 5. 报表中心-客服评价满意度
  客服评价满意度: [nameIdMap['客服评价满意度_tb'], nameIdMap['客服评价满意度_jd']],
  // 5. 报表中心-分析洞察Agent
  分析洞察Agent: [nameIdMap['龙虾']],
  // 6. 系统管理-质检效果监控
  质检效果监控: [nameIdMap['质检效果监控报表']],
  // VOC-商品咨询热点
  商品咨询热点: [
    nameIdMap['商品热点报告_tb'],
    nameIdMap['商品热点报告'],
    nameIdMap['商品咨询统计_tb'],
    nameIdMap['商品咨询统计'],
  ],
  // VOC-商品流失分析
  商品流失分析: [nameIdMap['商品流失报告_tb'], nameIdMap['商品流失报告']],
}

export const handleDataforceV2 = (data: IPage[], platform: string) => {
  const primary_pages = data.flatMap((item) => item.primary_pages) as IPage[]
  const dataforceV2 = Object.keys(V2DataforceList).map((item) => ({
    name: item,
    id: item,
    primary_pages: [
      ...V2DataforceList[item]
        .filter(
          (id: string) =>
            idPlatformMap[id]?.includes(platform) &&
            primary_pages.find((page: IPage) => page?.id === id)
        )
        .map((id: string) => {
          const curPage = primary_pages.find((page: IPage) => page?.id === id) as IPage
          const index = Object.values(nameIdMap).findIndex((idItem) => idItem === id)

          const curName = Object.keys(nameIdMap)[index]
          // 获取名字
          const [name] = (curName ?? '').split('_')
          return {
            ...curPage,
            name:
              name ||
              (curPage?.name?.includes('-doris')
                ? curPage.name.replace('-doris', '')
                : curPage?.name),
            hideInMenu: !idPlatformMap[id]?.includes(platform),
            icon: pageIconMap[id] || undefined,
          }
        }),

      ...(data.find((page) => page.name === item)?.primary_pages || []),
    ],
  }))

  return dataforceV2
}
